import { orderBy } from "lodash";
import { GraphUtils } from "../utils.service";
import { Injectable } from "@angular/core";


@Injectable({
    providedIn: 'root'
})
export class WordcloudService {
    constructor(
        private graphUtils: GraphUtils
    ) {}

    setWordData(words, moodToValueFn: (mood: string) => number, scoreToColorFn: (score: number) => string){
        const moodToValue = moodToValueFn || this.graphUtils.moodToValue;
        const scoreToColor = scoreToColorFn || this.graphUtils.scoreToColor;
        return words.map(word => {
            const occurenceSum = word.details.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.occurence;
            }, 0);

            const moodWeightSum = word.details.reduce((accumulator, currentValue) => {
                const moodScore = moodToValue(currentValue.mood);
                return accumulator + (currentValue.occurence * moodScore);
            }, 0);

            word.weight = occurenceSum;
            word.averageMood = (moodWeightSum / occurenceSum).toFixed(2);
            word.color = scoreToColor(word.averageMood);
            word.details = this.sortByMood(word.details);

            return word;
        });
    }

    sortByMood(details){
        const rank = {
            "excellent": 1,
            "good": 2,
            "average": 3,
            "hard": 4,
            "bad": 5
        };
        return orderBy(details, x => rank[x.mood])
    }

}